// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content006_wrapper__IqEQV","header":"Content006_header__iJOu3","title":"Content006_title__NP8KK","description":"Content006_description__RBL__"};